<div class="credit-card-profile-validator"
     fxLayout="row wrap"
     fxLayout.lt-md="column"
     fxLayoutGap="15px"
     fxFlex="100">

    <!--        -->
    <div class="profile-info" fxFlex="50">

        <!-- Image-->
        <div class="profile-name">
            <h3>{{profile.profileName}}</h3>
        </div>

        <!--            -->
        <div class="profile-image">
            <img [src]="validationImage"
                 alt="credit card profile image">
        </div>

    </div>

    <!--    -->
    <div class="credit-card-profile-form-section" fxFlex>
        <form class="credit-card-profile-form"
              [formGroup]="creditCardValidationForm"
              fxLayout="column">

            <!--            -->
            <div class="form-group" fxLayout="column">

                <!--                -->
                <div class="form-label" [ngSwitch]="profile.profileType">
                    <mat-label translate="ticket.profile.cardNumber"
                               *ngSwitchCase="eventProfileType.VISA"></mat-label>

                    <mat-label translate="ticket.profile.cardNumber"
                               *ngSwitchCase="eventProfileType.MASTERCARD"></mat-label>

                    <mat-label translate="ticket.profile.cardNumber" *ngSwitchDefault></mat-label>
                </div>

                <!--                 -->
                <div class="form-control credit-cart-control"
                     fxLayout="row wrap"
                     fxLayoutGap="20px">


                    <!--    Card Number && Bin Number                -->
                    <mat-form-field class="credit-card-number" appearance="outline">


                        <ng-container *ngIf="isMaskedCardNumberVisible() else noMaskCardNumber ">
                            <input matInput
                                   type='text'
                                   [formControlName]="validationFieldConfig.name"
                                   [specialCharacters]="['*', ' ']"
                                   [mask]="maskedCardNumber"
                                   [validation]="false"
                                   [showMaskTyped]="true">

                        </ng-container>


                        <!--                    Errors -->
                        <ng-container *ngFor="let validator of validationFieldConfig.validations;"
                                      ngProjectAs="mat-error">
                            <mat-error
                                    *ngIf="this.creditCardValidationForm.get(this.validationFieldConfig?.name)?.hasError(validator.name)"
                                    [translate]="validator.message"
                                    [translateParams]="{field:validationFieldConfig.label,min:6}">
                            </mat-error>
                        </ng-container>
                        <!--                Extra Control            -->
                        <mat-error
                                *ngIf="creditCardValidationForm.get(this.validationFieldConfig.name)?.hasError('inValidCardNo')"
                                translate="shared.validation.errors.cardNumberInValid">
                        </mat-error>
                    </mat-form-field>


                    <!--                    -->
                    <ng-template #noMaskCardNumber>
                        <input matInput
                               type='text'
                               [formControlName]="validationFieldConfig.name">
                    </ng-template>


                    <!--       Action Button             -->
                    <div class="validate-btn">
                        <button mat-flat-button
                                type="button"
                                (click)="onValidateProfile()"
                                [color]="isDiscountApplied ? 'warn':'primary'">
                            {{(isDiscountApplied ? 'shared.labels.discountApplied' : 'shared.labels.apply')|translate}}
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>



